import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=70ba184e&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=70ba184e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ba184e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70ba184e')) {
      api.createRecord('70ba184e', component.options)
    } else {
      api.reload('70ba184e', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=70ba184e&scoped=true&", function () {
      api.rerender('70ba184e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2J47z4ZymxpAG/JS/teamMember.vue"
export default component.exports